import Main from '@/views/common/main'
// 风控
export default [
    //'风控管理'
    {
        path: '/payManager',
        name: 'payManager',
        meta: {
            icon: 'ios-apps',
            title: '支付管理'
        },
        component: Main,
        children: [
            // 盘口支付通道配置
            {
                path: 'payChannelConf',
                name: 'payManager_payChannelConf',
                meta: { title: '盘口支付通道配置' },
                component: () => import('@p/payChannelConfig.vue')
            },
            //全局支付平台配置
            {
                path: 'globalPayConf',
                name: 'payManager_globalPayConf',
                meta: { title: '全局支付平台配置' },
                component: () => import('@p/globalPayConfig.vue')
            },
            // 盘口充值商城配置
            {
                path: 'rechargeConf',
                name: 'payManager_rechargeConf',
                meta: { title: '盘口充值商城配置' },
                component: () => import('@p/rechargeConfig/rechargeConfig.vue')
            },
            //支付通道数据统计
            {
                path: 'payChannelData',
                name: 'payManager_payChannelData',
                meta: { title: '支付通道数据统计' },
                component: () => import('@p/payChannelData.vue')
            },
            // 盘口代付通道配置
            {
                path: 'payForChannelConfig',
                name: 'payManager_payForChannelConfig',
                meta: { title: '盘口代付通道配置' },
                component: () => import('@p/payForChannelConfig.vue')
            },
            //全局代付平台配置
            {
                path: 'globalPayForConfig',
                name: 'payManager_globalPayForConfig',
                meta: { title: '全局代付平台配置' },
                component: () => import('@p/globalPayForConfig.vue')
            },
            //盘口支付订单查询
            {
                path: 'paymentorder',
                name: 'payManager_paymentorder',
                meta: { title: '盘口支付订单查询' },
                component: () => import('@p/paymentorder.vue')
            }
        ]
    }
]
// 数据报表
